import React, { Fragment } from 'react';

import { Alert, Margin } from '@zapier/design-system';

import ByCliToolMessage from 'app/developer-v3/components/ByCliToolMessage';

import GoPublicTrigger from './GoPublicTrigger';
import PrivateIntegrationMsg from './PrivateIntegrationMsg';

type Props = {
  isPrivateIntentionMsgVisible: boolean;
  isPublicIntention: boolean;
  isPublicIntentionElementVisible: boolean;
  onConfirmPublicIntention: () => Promise<void>;
  onDismissPrivateIntentionMsg: () => void;
};

function CLI({
  isPrivateIntentionMsgVisible,
  isPublicIntention,
  isPublicIntentionElementVisible,
  onConfirmPublicIntention,
  onDismissPrivateIntentionMsg,
}: Props) {
  return (
    <Fragment>
      <Alert>
        <ByCliToolMessage theme="light" />
      </Alert>
      {!isPublicIntentionElementVisible && isPrivateIntentionMsgVisible && (
        <Margin margin="30px 0 0">
          <PrivateIntegrationMsg onDismiss={onDismissPrivateIntentionMsg} />
        </Margin>
      )}
      {!isPublicIntention && (
        <GoPublicTrigger onConfirmIntention={onConfirmPublicIntention} />
      )}
    </Fragment>
  );
}

export default CLI;
